import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=02bdd1b4&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"
import style0 from "./announcement.vue?vue&type=style&index=0&id=02bdd1b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdd1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bdd1b4')) {
      api.createRecord('02bdd1b4', component.options)
    } else {
      api.reload('02bdd1b4', component.options)
    }
    module.hot.accept("./announcement.vue?vue&type=template&id=02bdd1b4&scoped=true", function () {
      api.rerender('02bdd1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/components/announcement.vue"
export default component.exports